import { User } from './types';

export default {
  requestingUser: (state: User) => (state.status === 'loading'),
  analysisCount: (state: User) => (state.companyAnalysisCount),
  farmsCount: (state: User) => (state.companyFarmsCount),
  analitica: (state: User) => (state.companyAnalitica),
  sentinela: (state: User) => (state.companySentinela),
  companyId: (state: User) => (state.companyId),
  companyClientId: (state: User) => (state.companyClientId),
  authorities: (state: User) => (state.authorities),
  isCreditScoreUser: (state: User) => (state.authorities?.some(it => it['name'] === 'CREDIT_SCORE_FULL') ?? false),
  isAdminUser: (state: User) => (state.authorities?.some(it => it['name'] === 'BACKOFFICE_ADMIN') ?? false),
};
